<ion-header>
  <ion-toolbar>
    <ion-title>Filters</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Date Range</ion-card-title>
    </ion-card-header>

    <ion-list>
        <ion-item (click)="selectDate(1)">
              <ion-label>From Date:</ion-label>
              <ion-label class="ion-text-end">{{ documentBeanQueueQuery.fromDate | date: 'dd/MM/yyyy' }}</ion-label> 
              <ion-icon slot="end" name="calendar"></ion-icon>
        </ion-item>

        <ion-item (click)="selectDate(2)">
                <ion-label>To Date:</ion-label>
                <ion-label class="ion-text-end">{{ documentBeanQueueQuery.toDate | date: 'dd/MM/yyyy' }}</ion-label>
                <ion-icon slot="end" name="calendar"></ion-icon>
        </ion-item>
            
    </ion-list>

  </ion-card>

  <ion-card >  
    <ion-card-header>
      <ion-card-title>Order by Date Synced</ion-card-title>
    </ion-card-header>

    <ion-list>
      <ion-radio-group value="{{configuration.documentBeanQueueOrdering}}"  (ionChange)="handleValueChange($event)">
        <ion-item>
          <ion-label>Ascending</ion-label>
            <ion-radio value="ascending" >

            </ion-radio>
        </ion-item>
        
        <ion-item>
          <ion-label>Descending</ion-label>
            <ion-radio value="descending" >

            </ion-radio>
        </ion-item>
        

      </ion-radio-group>
    </ion-list>  
  </ion-card>

<ion-button (click)="applyFilter()"  expand="full" shape="round" >Apply Filter</ion-button>

</ion-content>

